module.exports = __webpack_public_path__ + "assets/img/demologo.69454436.png";